import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { BinderDetails } from 'src/app/models/binder/binder-details.model';
import { BinderSessionWizardService } from 'src/app/services/sections/binder/binder-session-wizard.service';

@Injectable({
	providedIn: 'root'
})
export class BinderSessionDetailsResolver implements Resolve<Observable<BinderDetails>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderSessionWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		return this.binderWizardService
			.getBinderDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
